import { createRowId } from '~/utils/societePayloadBuilder/ids';

import { PROMO_CODE_PROMOTION } from '../constants';
import { createPromoDraftLabel } from '../promos';

import type { LuxPlusPromoCard, LuxPlusPromoCardCarouselState } from './types';

export function createDefaultPromoCard(
  draftLabel = createPromoDraftLabel(0),
  overrides: Partial<Omit<LuxPlusPromoCard, 'draftId' | 'draftLabel'>> = {},
): LuxPlusPromoCard {
  return {
    draftId: createRowId(),
    draftLabel,
    type: PROMO_CODE_PROMOTION,
    label: '',
    title: '',
    subtitle: '',
    expiresAt: '',
    eligibleRegions: ['AU'],
    promoCode: '',
    termsAndConditions: '',
    primaryActionText: '',
    primaryActionHref: '',
    ctaText: '',
    ctaLink: '',
    ...overrides,
  };
}

export function createDefaultPromoCardCarouselState(): LuxPlusPromoCardCarouselState {
  return {
    mode: 'promoCardCarousel',
    promos: [createDefaultPromoCard()],
  };
}
